import React from 'react';
import Slider, { Settings } from 'react-slick';
import ReactDOM from 'react-dom';
import { BreedCategory } from '../../../structures/models/breed';
import routes from '../../../utils/routes';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';
import FANextArrow from './components/fa-next-arrow';
import FAPrevArrow from './components/fa-prev-arrow';

interface BreedSimpleCarouselProps {
  breeds: BreedCategory[],
  state: string,
}

const BreedSimpleCarousel: React.FC<BreedSimpleCarouselProps> = ({ breeds, state }) => {
  const settings: Settings = {
    className: 'breed-simple-slider px-2',
    infinite: false,
    centerMode: false,
    nextArrow: <FANextArrow />,
    prevArrow: <FAPrevArrow />,
    variableWidth: true,
    rows: 1,
    swipeToSlide: true,
  };

  return (
    <Slider
      {...settings}
    >
      {breeds.map((breed) => (
        <div key={breed.id} className="px-1">
          <a
            href={routes.webBreedStateSearch(breed.slug, 'puppy', state)}
            className="btn btn-sm btn-info rounded-pill text-center d-flex my-3 px-3 align-items-center"
            style={{
              gap: '0.5rem',
              backgroundColor: getComputedCSSVariable('table-header-gray'),
              borderColor: getComputedCSSVariable('table-header-gray'),
              fontSize: '1rem',
              margin: '0 0.125rem',
            }}
          >
            {breed.name}
          </a>
        </div>
      ))}
    </Slider>
  );
};

export default BreedSimpleCarousel;

const elements = [...document.getElementsByClassName('react-breed-simple-carousel')];
if (elements.length > 0) {
  elements.forEach((element) => {
    const state = element.getAttribute('data-state') ?? '';
    const breeds = JSON.parse(element.getAttribute('data-breeds') ?? '[]');
    ReactDOM.render(<BreedSimpleCarousel breeds={breeds} state={state} />, element);
  });
}
